/**
 * <mb-recommendations>: busca os relacionados e troca o próprio elemento pelo carrossel renderizado (a
 * section volta pronta, com <mb-carousel> e os cards). A URL é a da tag `produtos-relacionados-*`
 * (/collections/all/<tag>?section_id=vitrine-tag, como o site atual) ou a da API de recomendações da Shopify.
 * `data-exclude` tira o próprio produto da lista; sem nenhum outro produto, o elemento some.
 */
class MbRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            this.load();
          }
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(this);
    } else {
      this.load();
    }
  }

  async load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.related-products');
      if (section && this.dataset.exclude) {
        section.querySelectorAll(`[data-product-id="${this.dataset.exclude}"]`).forEach((card) => (card.closest('.swiper-slide') || card).remove());
      }
      if (section && section.querySelector('[data-product-id]')) this.replaceWith(section);
      else this.remove();
    } catch (error) {
      this.remove();
    }
  }
}

if (!customElements.get('mb-recommendations')) customElements.define('mb-recommendations', MbRecommendations);
